// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__E-fIu","search__wrapper":"styles_search__wrapper__1rWMj","arbutton__add":"styles_arbutton__add__7I57o"};